import { cn } from "ui";
import {
  EntityCardSkeleton,
  type EntityCardSkeletonProps,
} from "../primitives/EntityCardSkeleton";

type EntityCardGridSkeletonProps = {
  /** Number of card placeholders to render.
   * @default 9
   */
  count?: number;
  /** Header image/icon size forwarded to each card.
   * @default 72
   */
  imageDimensions?: EntityCardSkeletonProps["imageDimensions"];
  /** Render the divider + body line on each card.
   * @default true
   */
  withBody?: boolean;
  /** Classes for the grid wrapper (override the default responsive columns). */
  className?: string;
  /** Classes applied to each card. */
  cardClassName?: string;
};

/**
 * Loading placeholder grid of `EntityCardSkeleton` cards. Renders `count`
 * cards (default 9) in a responsive grid that mirrors the providers modal /
 * risk rules / flows listing layout. Customize the columns via `className`.
 */
export const EntityCardGridSkeleton = ({
  count = 9,
  imageDimensions = 72,
  withBody = true,
  className,
  cardClassName,
}: EntityCardGridSkeletonProps) => (
  <div
    className={cn(
      "grid w-full grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3",
      className
    )}
  >
    {Array.from({ length: count }).map((_, index) => (
      <EntityCardSkeleton
        key={index}
        imageDimensions={imageDimensions}
        withBody={withBody}
        className={cardClassName}
      />
    ))}
  </div>
);
